import DeclinedMessageModal from './DeclinedMessageModal';

export default DeclinedMessageModal;
